<template>
  <nav class="navbar">
    <div class="navbar-container">
      <!-- Branding -->
      <div class="navbar-branding">
        <div class="navbar-logo">
          <img src="https://firebasestorage.googleapis.com/v0/b/producer-feedback.firebasestorage.app/o/BASE%2Fecho-logo_v2.svg?alt=media&token=51106614-9e53-474c-832f-bf7e195e0439" alt="Echo Logo"/>
        </div>
      </div>

      <!-- Mobile menu toggle button -->
      <button class="mobile-menu-toggle" @click="toggleMobileMenu">
        ☰
      </button>

      <!-- Navigation Links & Actions -->
      <div class="navbar-links" :class="{ 'mobile-open': mobileMenuOpen }">
        <div class="nav-link-group">
          <!-- Projects Dropdown (for admin and production) -->
          <div class="dropdown" v-if="isLoggedIn && (userRole === 'admin' || userRole === 'production')">
            <button class="nav-link dropdown-button">Projects</button>
            <div class="dropdown-content">
              <AppNavLink class="nav-link" to="/projectlist">Active projects</AppNavLink>
              <span class="nav-link disabled">Archived</span>
            </div>
          </div>

          <!-- Resources Dropdown (for admin and production) -->
          <div class="dropdown" v-if="isLoggedIn && (userRole === 'admin' || userRole === 'production')">
            <button class="nav-link dropdown-button">Resources</button>
            <div class="dropdown-content">
              <AppNavLink class="nav-link" to="/dev">Blog</AppNavLink>
              <AppNavLink class="nav-link" to="/help">Help</AppNavLink>
              <AppNavLink class="nav-link" to="/tickets">Bug report</AppNavLink>
            </div>
          </div>

          <!-- Admin Tools Dropdown (for admin only) -->
          <div class="dropdown" v-if="isLoggedIn && userRole === 'admin'">
            <button class="nav-link dropdown-button">Admin tools</button>
            <div class="dropdown-content">
              <AppNavLink class="nav-link" to="/members">Member management</AppNavLink>
              <AppNavLink class="nav-link" to="/knowledge-editor">Help Editor</AppNavLink>
              <AppNavLink class="nav-link" to="/announcement-editor">Announcements</AppNavLink>
            </div>
          </div>

          <!-- Login Link if not logged in -->
          <div v-if="!isLoggedIn">
            <AppNavLink class="nav-link" to="/login">Login</AppNavLink>
          </div>
        </div>

        <!-- Additional Dropdowns for logged-in users -->
        <div class="nav-dropdown-actions" v-if="isLoggedIn">
          <!-- Notification Dropdown -->
          <div class="dropdown">
            <button class="nav-link dropdown-button">
              <img src="https://firebasestorage.googleapis.com/v0/b/producer-feedback.firebasestorage.app/o/BASE%2Fnotification.svg?alt=media&amp;token=8e2bbeac-7e35-4892-831a-4b3a475526d9" alt="Notifications" height="24">
            </button>
            <div class="dropdown-content">
              <span class="nav-link disabled">✨ Notifications in development</span>
            </div>
          </div>

          <!-- Profile Dropdown -->
          <div class="dropdown">
            <router-link to="/profile/dashboard" class="nav-link dropdown-button">
              <img src="https://firebasestorage.googleapis.com/v0/b/producer-feedback.firebasestorage.app/o/BASE%2Fprofile.svg?alt=media&amp;token=91e6571c-7ca3-4693-b6e9-b1425fc1c252" alt="Profile" height="24">
            </router-link>
            <div class="dropdown-content">
              <AppNavLink class="nav-link" to="/profile/dashboard">Dashboard</AppNavLink>
              <AppNavLink class="nav-link" to="/profile">Profile</AppNavLink>
              <span class="nav-link" @click="logout">Log out</span>
            </div>
          </div>
        </div>
        <!-- Dark Mode Toggle -->
        <div class="navbar-actions">
          <button class="darkmode-toggle" @click="toggleDarkMode"></button>
        </div>
      </div>
    </div>
  </nav>
</template>

<script>
import { ref, onMounted } from 'vue';
import { auth, db } from '../firebaseConfig';
import { signOut } from 'firebase/auth';
import { doc, getDoc } from 'firebase/firestore';
import AppNavLink from './AppNavLink.vue';

export default {
  name: 'NavBar',
  components: { AppNavLink },
  setup() {
    const mobileMenuOpen = ref(false);
    const isLoggedIn = ref(false);
    const userRole = ref('');

    const toggleMobileMenu = () => {
      mobileMenuOpen.value = !mobileMenuOpen.value;
    };

    const logout = async () => {
      try {
        await signOut(auth);
        window.location.href = '/login';
      } catch (error) {
        console.error('Error logging out:', error);
      }
    };

    const toggleDarkMode = () => {
      if (document.documentElement.classList.contains('dark')) {
        document.documentElement.classList.remove('dark');
        localStorage.setItem('darkMode', 'disabled');
      } else {
        document.documentElement.classList.add('dark');
        localStorage.setItem('darkMode', 'enabled');
      }
    };

    onMounted(() => {
      auth.onAuthStateChanged(async (user) => {
        isLoggedIn.value = !!user;
        if (user) {
          const userDocRef = doc(db, 'users', user.uid);
          const userDocSnap = await getDoc(userDocRef);
          userRole.value = userDocSnap.exists() ? userDocSnap.data().role : '';
        } else {
          userRole.value = '';
        }
      });
    });

    return { mobileMenuOpen, toggleMobileMenu, isLoggedIn, userRole, logout, toggleDarkMode };
  },
};
</script>

<style src="./navbar.css" scoped></style>
<style src="./loginPage.css" scoped></style>
<style src="./base.css" scoped></style>
<style>
@import url('https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,400;0,500;0,800;1,800&display=swap');
</style>
